<template>
  <v-container>
    <v-dialog v-model="openFlag" max-width="800">
      <c-card :title="onDialogTitle" class="white">
        <v-row align="center">
          <v-col cols="3">일시 <span class="red--text">*</span></v-col>
          <v-col cols="9">
            <v-row align="center">
              <v-menu
                ref="dateMenu"
                v-model="dateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on}">
                  <v-text-field
                    v-model="refuelingInfo.selectedDate"
                    prepend-icon="event"
                    readonly densd
                    v-on="on"
                  ></v-text-field>
                </template>
                <c-date-picker
                  v-model="refuelingInfo.selectedDate" @input="dateMenu = false" firstDayOfWeek="1" :selectedDate="refuelingInfo.selectedDate"
                  noTitle="true" scrollable="true" locale="ko-kr">
                </c-date-picker>
              </v-menu>
              <c-time-picker
                v-model="refuelingInfo.selectedTime"
                :minute-interval="5"
                :h-range="[0,24]"
                :autoScroll="true"
                :defaultAutoScrollValue="7"
              ></c-time-picker>
            </v-row>
          </v-col>

          <v-col cols="3">주유량 <span class="red--text">*</span></v-col>
          <v-col cols="9">
            <v-text-field v-model="refuelingInfo.liter" style="display: inline-block" :rules="[rules.numberOnly]"></v-text-field>
            <span>L</span>
          </v-col>

          <v-col cols="3">주유소 <span class="red--text">*</span></v-col>
          <v-col cols="9">
            <v-menu v-model="gasStationListMenu" offset-y max-height="300px" max-width="500px">
              <template v-slot:activator="{}">
                <v-row class="my-0 py-0">
                  <v-col cols="10" class="mt-0 pt-0">
                    <v-text-field v-model="refuelingInfo.gasStation" placeholder="주유소를 검색해주세요." :rules="[rules.requiredCharacter]"
                                  @keyup.enter="onSetAddress" hide-details></v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <c-btn outlined color="blue" @click="onSetAddress">검색</c-btn>
                  </v-col>
                </v-row>
              </template>
              <v-list>
                <v-list-item v-for="(item, idx) in gasStationList" :key="idx" @click="onSelectAddr(item)">
                  <v-icon class="pr-3" color="blue">place</v-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{item.placeName}}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{item.address}}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-if="item.roadAddress">
                      <v-chip x-small shaped pill label> 지번</v-chip> {{item.roadAddress}}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>

          </v-col>

          <v-col cols="3">금액 (원) <span class="red--text">*</span></v-col>
          <v-col cols="9">
            <v-text-field v-model="refuelingInfo.price" style="display: inline-block" :rules="[rules.numberOnly]"></v-text-field>
            <span>원</span>
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <c-btn v-if="isNew" outlined color="blue" @click="onAddRefueling" class="mx-2"> 등록</c-btn>
          <c-btn v-else outlined color="blue" @click="onUpdateRefueling" class="mx-2"> 수정</c-btn>
          <c-btn @click="openFlag = false" outlined color="black"> 닫기</c-btn>
        </v-row>

      </c-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    props:{
      open : {
        type: Boolean,
        default: false
      },
      defaultInfo: {
        type : Object,
        default : null
      }
    },
    data:() => ({
      isNew: true,
      openFlag: null,
      dateMenu : false,

      refuelingInfo : {
        selectedDate: '',
        selectedTime:'',
        liter:'',
        gasStation: '',
        price : '',
      },
      rules: {
        numberOnly: (value) => (/(^\d+$)|(^\d+.\d+$)/g).test(value) || '숫자만 입력가능합니다.',
        requiredCharacter: (value) => value && /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(value)|| '주유소 정보를 올바르게 입력해주세요.',
      },
      gasStationList:[],
      gasStationListMenu : false,
    }),
    watch: {
      open(val) {
        this.initData();
        if(val && this.defaultInfo.id){
          this.isNew = false;
          const info = {...this.defaultInfo};
          this.refuelingInfo = {
            selectedDate : info.date,
            selectedTime : info.time,
            liter : info.liter,
            gasStation : info.gasStation,
            price : info.price
          }
        }
        this.openFlag = val;
      },
      openFlag(val) {
        if(!val){
          this.defaultInfo.id = null;
          this.initData();
        }
        this.$emit('update:open', this.openFlag)
      }
    },
    computed:{
      onDialogTitle(){
        return this.isNew? '주유 내역 등록' : '주유 내역 수정';
      }
    },
    methods: {
      initData() {
        this.refuelingInfo = {
          selectedDate: this.$func.curDateString(),
          selectedTime: '00:00',
          liter:'',
          gasStation: '',
          price : '',
        };
        this.isNew = true;
        this.gasStationList = [];
        this.gasStationListMenu = false;
      },
      nullCheck(){
        if(!this.refuelingInfo.selectedDate || !this.refuelingInfo.selectedTime || !this.refuelingInfo.liter
          || !this.refuelingInfo.gasStation || !this.refuelingInfo.price) {
          return false;
        }
        return true;
      },
      regxCheck() {
        if((/!(^\d+$)|!(^\d+.\d+$)/g).test(this.refuelingInfo.liter)||  (/[^0-9]/g).test(this.refuelingInfo.price)|| /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(this.refuelingInfo.location)) {
          return false;
        }
        return true;
      },
      onAddRefueling(){
        if(!this.nullCheck()) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '비어있는 필드가 있습니다.'});
          return;
        }

        if(!this.regxCheck()) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '입력양식이 올바르지 않습니다.'});
          return;
        }
        this.$emit('reqAddRefueling', this.refuelingInfo)
      },
      onUpdateRefueling(){
        if(!this.nullCheck()) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '비어있는 필드가 있습니다.'});
          return;
        }

        if(!this.regxCheck()) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '입력양식이 올바르지 않습니다.'});
          return;
        }
        this.refuelingInfo['id'] = this.defaultInfo.id;
        this.$emit('reqUpdateRefueling', this.refuelingInfo)
      },
      async onSetAddress() {
        const location = this.refuelingInfo.gasStation;

        if (!(location.replace(/^\s+|\s+$/g, ''))) {
          this.$store.commit('snackbar', {color:'blue', msg:'검색어를 입력해주세요.'});
          return false;
        }

        try {
          let ps = new kakao.maps.services.Places();
          let lat = this.$store.state.userInfo.centerPoint.split(',')[1];
          let lng = this.$store.state.userInfo.centerPoint.split(',')[0];

          await ps.categorySearch('OL7', (data, status, pagination) => {
            if (status === kakao.maps.services.Status.ZERO_RESULT) {
              this.$store.commit('snackbar', {msg: '검색 결과가 존재하지 않습니다.'});
            } else if (status === kakao.maps.services.Status.ERROR) {
              this.$store.commit('snackbar', {msg: '검색 중 오류가 발생했습니다.'});
            } else if(status === kakao.maps.services.Status.OK) {
              for(let idx in data) {
                let item = data[idx];
                this.gasStationList.push({
                  placeName : item.place_name,
                  address : item.address_name,
                  roadAddress : item.road_address_name,
                })
              }
              this.gasStationListMenu = true;
            }
          }, {
            x: lng,
            y: lat
          });
        } catch (err) {
          this.$store.commit('snackbar', {where : 'RefuelingCUDialog - onSetAddress'})
        }
      },
      onSelectAddr(data) {
        this.refuelingInfo.gasStation = data.placeName;
      }
    }
  }
</script>

<style scoped>

</style>